"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recursiveClone = exports.isPlainObject = void 0;
function isPlainObject(value) {
    if (Object.prototype.toString.call(value) !== '[object Object]') {
        return false;
    }
    var prototype = Object.getPrototypeOf(value);
    return prototype === null || prototype === Object.prototype;
}
exports.isPlainObject = isPlainObject;
function recursiveClone(obj) {
    var target = {};
    for (var key in obj) {
        var value = obj[key];
        if (isPlainObject(value)) {
            target[key] = recursiveClone(value);
        }
        else {
            target[key] = value;
        }
    }
    return target;
}
exports.recursiveClone = recursiveClone;
